import React from 'react';

export const CaretIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="General Function Icons" clipPath="url(#clip0_360_49991)">
      <g id="keyboard_arrow_left">
        <mask
          id="mask0_360_49991"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="25"
        >
          <rect
            id="Bounding box"
            y="0.5"
            width="24"
            height="24"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_360_49991)">
          <path
            id="keyboard_arrow_left_2"
            d="M14 18.5L8 12.5L14 6.5L15.4 7.9L10.8 12.5L15.4 17.1L14 18.5Z"
            fill="#E4E4E4"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_360_49991">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
